import { length, lineString } from "@turf/turf";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";

import { getSelected } from "../state/existingLeveeEditsMenu";

import CollapsableSidebarStyles from "./CollapsableSidebar.module.css";
import { FormLabel } from "./FormLabel";
import RightMenuHeader from "./RightMenuHeader";
import styles from "./SelectedRasterEditInspector.module.css";

const SelectedLeveeEditInspector: React.FC = () => {
  const selectedEdit = useSelector(getSelected);

  const turfPolygon = selectedEdit && lineString(selectedEdit.linestring.coordinates);
  const distance = turfPolygon && length(turfPolygon, { units: "kilometers" });

  return (
    <div className={`${CollapsableSidebarStyles.LeftMenu}`}>
      <RightMenuHeader
        parent={"LEVEEEDIT"}
        titleElement={
          <FormattedMessage id="selectedLeveeEditInspector.title" defaultMessage="Flood barrier" />
        }
      />
      <FormLabel>Details</FormLabel>

      {selectedEdit ? (
        <div>
          <div className={styles.Detail}>
            <span>
              <FormattedMessage id="selectedLeveeEditInspector.height" defaultMessage="Height" />
            </span>
            <span>{selectedEdit.value} mMSL</span>
          </div>
          <div className={styles.Detail}>
            <span>
              <FormattedMessage
                id="selectedLeveeEditInspector.distance"
                defaultMessage="Distance"
              />
            </span>
            <span>{distance && Math.round(distance * 1000)} (m)</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default connect(null, {})(SelectedLeveeEditInspector);
